// Keep in sync with Corp::Mutations::ConsumeCorporateVerificationToken error codes
export const CORPORATE_VERIFICATION_ERROR_CODES = {
  INVALID_TOKEN: 'invalid_corporate_verification_token',
  WRONG_ACCOUNT: 'wrong_account_corporate_verification',
} as const;

export type CorporateVerificationErrorCode =
  (typeof CORPORATE_VERIFICATION_ERROR_CODES)[keyof typeof CORPORATE_VERIFICATION_ERROR_CODES];
